import React, { useState, useEffect } from 'react';

interface Props { taskId?: string | null; }

const OmnigateUsePreview: React.FC<Props> = ({ taskId }) => {
  const [iframeKey, setIframeKey] = useState(0);
  const [mode, setMode] = useState<'iframe' | 'screenshots'>('iframe');
  const [screenshotData, setScreenshotData] = useState({ b64: '', err: '' });

  useEffect(() => {
    if (mode === 'screenshots') {
      const interval = setInterval(async () => {
        try {
          const res = await fetch('/v1/omnigate-use/agent/screenshot');
          if (res.ok) {
            const data = await res.json();
            if (data.success && data.base64) {
              setScreenshotData({ b64: data.base64, err: '' });
            } else {
              setScreenshotData(s => ({ ...s, err: 'Brak obrazu' }));
            }
          } else {
            setScreenshotData(s => ({ ...s, err: `API HTTP ${res.status}` }));
          }
        } catch (e: any) {
          setScreenshotData(s => ({ ...s, err: e.message }));
        }
      }, 2500); // co 2.5s
      return () => clearInterval(interval);
    }
  }, [mode]);

  return (
    <div className="h-full flex flex-col bg-black overflow-hidden">
      <div className="flex items-center justify-between px-3 py-1.5 border-b border-[#2a2e39] bg-[#131722] shrink-0">
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse shadow-[0_0_8px_#22c55e]" />
          <span className="text-[9px] font-black uppercase tracking-wider text-blue-400">🌐 Agent Screen</span>
          {taskId && <span className="text-[7px] text-slate-500 font-mono ml-1">{taskId.slice(0, 8)}</span>}
        </div>
        <div className="flex gap-2 items-center">
          <select 
            value={mode} 
            onChange={(e) => setMode(e.target.value as 'iframe' | 'screenshots')}
            className="text-[8px] bg-[#1a1d2e] border border-[#2a2e39] text-gray-300 rounded px-1 outline-none"
          >
            <option value="iframe">noVNC IFrame</option>
            <option value="screenshots">Snippets (API)</option>
          </select>
          {mode === 'iframe' && (
            <button onClick={() => setIframeKey(k => k + 1)} className="text-[8px] bg-slate-800 hover:bg-slate-700 text-slate-400 px-2 py-0.5 rounded border border-slate-700">🔄 IFrame</button>
          )}
        </div>
      </div>
      <div className="flex-1 relative bg-black flex items-center justify-center overflow-hidden">
        {mode === 'iframe' ? (
          <iframe
            key={iframeKey}
            src="http://localhost:7910/vnc.html?autoconnect=1&resize=scale&show_dot=1&view_only=0"
            className="w-full h-full border-0 absolute inset-0"
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            title="Omnigate Use Agent Screen"
            onLoad={() => console.log('[OmnigateUse] VNC iframe loaded')}
          />
        ) : (
          <div className="w-full h-full p-2 flex flex-col items-center justify-center relative">
            {screenshotData.b64 ? (
              <img src={`data:image/png;base64,${screenshotData.b64}`} alt="Agent Screen" className="max-w-full max-h-full object-contain rounded shadow-lg border border-slate-800" />
            ) : (
              <div className="text-slate-600 text-[10px] animate-pulse">Waiting for screenshot...</div>
            )}
            {screenshotData.err && <div className="absolute bottom-2 right-2 bg-red-900/80 text-red-300 px-2 py-1 text-[8px] rounded">{screenshotData.err}</div>}
          </div>
        )}
      </div>
      <div className="flex items-center gap-3 px-3 py-1 border-t border-[#2a2e39] bg-[#131722] text-[7px] text-slate-500 font-mono shrink-0">
        <span>Port: 7910</span>
        <span className="text-green-400">● LIVE</span>
      </div>
    </div>
  );
};

export default OmnigateUsePreview;
